import { TOTP } from 'otpauth';

type TOTPConfig = ConstructorParameters<typeof TOTP>[0];

const TOTP_CONFIG: TOTPConfig = {
  digits: 6,
  algorithm: 'sha1',
  period: 30,
};

export type TimedOTP = {
  otp: string;
  expiration: Date;
};

export const generateTimedOTP = (secret: string): TimedOTP => {
  const totp = new TOTP({
    secret,
    ...TOTP_CONFIG,
  });

  return {
    otp: totp.generate(),
    expiration: new Date(Date.now() + totp.period * 1000),
  };
};
